import jwtDecode from 'jwt-decode';
import swal from 'sweetalert';
import { getObject } from './api';
import { getToken } from './SessionController';

const userCache = 60 * 60 * 1000; // 1 hour cache

export const getUser = async (forceReset) => {
  if (sessionStorage.user && sessionStorage.userTimestamp && !forceReset) {
    const ts = parseInt(sessionStorage.userTimestamp);

    if (new Date() - ts < userCache) {
      return JSON.parse(sessionStorage.user);
    }
  }

  const id = jwtDecode(getToken())?.id;

  if (id) {
    const response = await getObject('user', {
      filter: {
        _id: id,
      },
    });

    if (response.success) {
      const newUser = response.data[0];

      sessionStorage.user = JSON.stringify(newUser);
      sessionStorage.userTimestamp = new Date().getTime().toString();

      return newUser;
    } else {
      swal('Error', 'Unable to get user', 'error');
    }
  } else {
    swal('Error', 'Unable to get read ID from token', 'error');
  }
  return null;
};
